var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 5.66671C13.955 5.66671 14.9997 4.62203 14.9997 3.33335C14.9997 2.04468 13.955 1 12.6664 1C11.3777 1 10.333 2.04468 10.333 3.33335C10.333 4.62203 11.3777 5.66671 12.6664 5.66671Z",
    stroke: "white",
    strokeWidth: 1.55557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 11.111C4.62203 11.111 5.66671 10.0664 5.66671 8.77769C5.66671 7.48901 4.62203 6.44434 3.33335 6.44434C2.04468 6.44434 1 7.48901 1 8.77769C1 10.0664 2.04468 11.111 3.33335 11.111Z",
    stroke: "white",
    strokeWidth: 1.55557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 16.5554C13.955 16.5554 14.9997 15.5107 14.9997 14.222C14.9997 12.9333 13.955 11.8887 12.6664 11.8887C11.3777 11.8887 10.333 12.9333 10.333 14.222C10.333 15.5107 11.3777 16.5554 12.6664 16.5554Z",
    stroke: "white",
    strokeWidth: 1.55557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34766 9.95312L10.6599 13.0487",
    stroke: "white",
    strokeWidth: 1.55557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6521 4.50781L5.34766 7.60339",
    stroke: "white",
    strokeWidth: 1.55557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.a7ff2e95459cdd628a39cba6cc70ba1d.svg";
export { ForwardRef as ReactComponent };